import { render, staticRenderFns } from "./candidateFormError.vue?vue&type=template&id=028f779c&"
import script from "./candidateFormError.vue?vue&type=script&lang=js&"
export * from "./candidateFormError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports